import React from 'react'

import { PlannerItemResponse } from '@/types/Planner'

type Props = {
  data: PlannerItemResponse[]
  onItemClick: (event: PlannerItemResponse) => void
}

const UnscheduledDayItems = ({ data, onItemClick }: Props) => {
  if (!data || data?.length <= 0) return null
  return (
    <div className="flex flex-nowrap items-center overflow-x-auto overflow-y-hidden bg-grey-100 py-2">
      <div className="black mx-3 text-xs" style={{ fontWeight: 700 }}>
        Unscheduled
      </div>
      {data?.map((item) => {
        return (
          <div
            className="mr-4 shrink-0 grow-0 basis-auto cursor-pointer rounded-lg px-4 py-1 text-xs capitalize text-white"
            key={item?.recordId}
            onClick={() => onItemClick(item)}
            role={'presentation'}
            style={{ backgroundColor: item.color }}
          >
            {item?.name || item?.type}
          </div>
        )
      })}
    </div>
  )
}

export default UnscheduledDayItems
